export const SERVICE_PROVISION = 'serviceProvision'
export const VISITOR_STATISTICS = 'visitorStatistics'
